import React from 'react'
import SmallBreadcrumbs from '../../components/layout/navigation/components/SmallBreadcrumbs.jsx'

let Ribbon = React.createClass({
    render: function(){
        return (
            <div id="ribbon">
                <SmallBreadcrumbs />
            </div>
        )
    }
});

export default Ribbon



// WEBPACK FOOTER //
// ./src/pages/layout/Ribbon.jsx